"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var onEnter_1 = __importDefault(require("./onEnter"));

var onBackspace_1 = __importDefault(require("./onBackspace"));

var KEY_ENTER = 'Enter';
var KEY_BACKSPACE = 'Backspace';
/**
 * User is pressing a key in the editor
 */

var onKeyDown = function onKeyDown(opts) {
  return function (event, editor, next) {
    var _event = event;

    switch (_event.key) {
      case KEY_ENTER:
        return onEnter_1.default(_event, editor, opts, next);

      case KEY_BACKSPACE:
        return onBackspace_1.default(_event, editor, opts, next);

      default:
        return next();
    }
  };
};

exports.default = onKeyDown;